import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ChangeDetectorRef, ElementRef, Input , Pipe, PipeTransform, Output, EventEmitter , ViewEncapsulation,AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';

import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ActivatedRoute, Router } from '@angular/router';

import { CustomerService } from '../../../services/customer.service';
import { GlobalsService } from '../../../services/globals.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate , query, group, stagger } from '@angular/animations';
import { Customer } from '../../../classes/customer';
import { Location } from '@angular/common'


@Component({
	selector: 'app-customer-ar',
	templateUrl: './customer-ar.component.html',
	styleUrls: ['./customer-ar.component.scss'],
	animations: [
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
			// :enter is alias to 'void => *'
				style({ height: '0',width: '0' }),
				animate(200, style({ height: '*' , width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
			// :leave is alias to '* => void'
				animate(300, style({ height: 0, width: 0  })),
				animate('300ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class CustomerArComponent implements OnInit, OnDestroy, OnChanges {

	@Input() customer;
	@Output() editing = new EventEmitter<boolean>();
	@Output() newcustomerdata = new EventEmitter<boolean>();

	arForm: any = false;
	areas: any = [];
	holdreasons: any = [];
	terms: any = [];
	currencies: any = [];
	disabletrans = false;
	disabledbranch = false;
	tirefee = true;
	requirepo = false;
	formEditAllowed = [
		'debtorno',
		'branchcode','disabletrans',
		'tirefee',
		'customerpoline',
		'currabrev',
		'termsindicator',
		'creditlimit',
		'arintrate',
		'currcode',
		'holdreason',
		'paymentterms',
		'emailstatement',
		'statementemailaddress',
		'ediinvoices',
		'invoiceemailaddress',
		'edireference',
		'nochecks'
	];
	config: any = false;

	constructor(public globalSearchService: GlobalSearchService, private route: ActivatedRoute, private fb: UntypedFormBuilder,private customerService: CustomerService, public router: Router, private location: Location, private globalsService: GlobalsService) {

		this.globalsService.getHoldReasons().subscribe(details => {
			this.holdreasons = details;
		});

		this.globalsService.getTerms().subscribe(details => {
			this.terms = details;
		});

		this.globalSearchService.configsubscription.subscribe(c => {
			this.config = c;
		});
		
		this.globalSearchService.helpManualAvailable$.next('customers_edit_customer-ar');
		

		this.globalsService.getCurrencies().subscribe(details => {
			this.currencies = details;
		});
	}

	ngOnInit(): void {
		this.buildArForm();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['customer'] && this.customer?.customer) {
			this.buildArForm();
		}
	}

	/** Template binds fixed controls; API payloads may omit keys — always register every AR field. */
	private buildArForm(): void {
		const details = this.customer?.customer;
		if (!details) {
			this.arForm = null;
			return;
		}
		const defaults: Record<string, string | boolean> = {
			tirefee: true,
			customerpoline: false,
			emailstatement: false,
			ediinvoices: false,
			nochecks: false,
			creditlimit: '',
			holdreason: '',
			termsindicator: '',
			currcode: '',
			edireference: '',
			statementemailaddress: '',
			invoiceemailaddress: '',
			arintrate: '',
			paymentterms: '',
			debtorno: '',
			branchcode: '',
			disabletrans: false,
			currabrev: '',
		};
		const formGroup = new UntypedFormGroup({});
		this.formEditAllowed.forEach((key) => {
			const fromApi = details[key];
			const fallback = defaults[key];
			const value =
				fromApi !== undefined && fromApi !== null
					? fromApi
					: fallback !== undefined
						? fallback
						: '';
			formGroup.addControl(key, new UntypedFormControl(value, []));
		});
		this.arForm = formGroup;
	}

	back(): void {
		this.editing.emit(false);
	}

	onSubmit() {

		this.globalSearchService.getFormValidationErrors(this.arForm);
		const proceed = true;
		if(proceed) {
			if(this.arForm.valid) {
				this.customerService.updateDebtorAr(this.arForm.value).subscribe( (results) => {
					this.newcustomerdata.emit(results);
					this.editing.emit(false);
				})
			}
		}
	}
	
	ngOnDestroy() {
		this.globalSearchService.helpManualAvailable$.next(null);
	}

}
